import React, { useEffect } from 'react';
import styled from 'styled-components';
import { NavigationBar } from '@oneaudi/unified-web-components';
import { useI18n } from '@oneaudi/i18n-context';
import mapContext from '../../../contexts/map-context';
import { ActionTypes } from '../../../contexts/reducers/map-reducer';
import { ReviewCategory } from '../../../types';
import { messages } from '../../../i18n/messages';
import { DISPLAY_SIZE } from '../../common/global.style.constants';

const device = {
  desktop: `(min-width:${DISPLAY_SIZE.DESKTOP})`,
  largeDesktop: `(min-width:${DISPLAY_SIZE.LARGE_DESKTOP})`,
  smallDesktop: `(min-width:${DISPLAY_SIZE.SMALL_DESKTOP})`,
  mobile: `(max-width:${DISPLAY_SIZE.MOBILE})`,
  tablet: `(min-width: ${DISPLAY_SIZE.TABLET})`,
  smallTablet: `(max-width: ${DISPLAY_SIZE.TABLET})`,
};

const SELECTION = ['ALL', 'SALES', 'SERVICE'];

const SelectionBarContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 32px;
`;

const NavigationBarStyled = styled(NavigationBar)`
  width: 100%;
  justify-content: center;

  > div {
    button {
      width: 30px;
      @media ${device.tablet} {
        width: auto;
      }
    }
  }

  button {
    min-width: 30px;
    justify-content: flex-end;
  }
`;

export const ServiceSelectionBar = () => {
  const { reviewCategoryFilter } = mapContext.useMapState();
  const selectionText: { [key: string]: string } = {
    ALL: useI18n(messages.five_star_all_services),
    SALES: useI18n(messages.five_star_sales_category),
    SERVICE: useI18n(messages.five_star_service_category),
  };
  const dispatch = mapContext.useMapDispatch();
  const onSelect = (category: ReviewCategory) => {
    dispatch({ type: ActionTypes.setReviewCategoryFilter, payload: category });
  };
  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 1000);
  }, []);
  const navigationItems = SELECTION.map((category) => {
    return {
      active: category === reviewCategoryFilter,
      label: selectionText[category],
      onClick: () => onSelect(category as ReviewCategory),
    };
  });

  return (
    <SelectionBarContainer>
      <NavigationBarStyled
        id="nav-bar__scrolling"
        size="md"
        scrollButtons={{
          left: {
            ariaLabel: 'Scroll Back',
          },
          right: {
            ariaLabel: 'Scroll Forward',
          },
        }}
        items={navigationItems}
      />
    </SelectionBarContainer>
  );
};
